"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SettingsItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./settings-item.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SettingsItem = function SettingsItem(_ref) {
  var dataKey = _ref.dataKey,
      label = _ref.label,
      onToggle = _ref.onToggle,
      visible = _ref.visible;
  return /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: dataKey,
    className: "settings-item"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    id: dataKey,
    type: "checkbox",
    checked: visible,
    onChange: function onChange() {
      return onToggle({
        dataKey: dataKey,
        visible: !visible
      });
    }
  }), label);
};

exports.SettingsItem = SettingsItem;
SettingsItem.propTypes = {
  dataKey: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].node.isRequired,
  onToggle: _propTypes["default"].func,
  visible: _propTypes["default"].bool
};

var noop = function noop() {};

SettingsItem.defaultProps = {
  visible: false,
  onToggle: noop
};
var _default = SettingsItem;
exports["default"] = _default;